import {baseUrl, razorpayId} from "../Constants";
import {getData} from "./Request";
import {parseDecimal} from "./Utilities";


const requestHeaders = ({
                            app_key,
                            user_id
                        }) => {
    return {
        "x-appkey": app_key || "rcmroes1UWF2GIcBBQ5jghe6xpwoQ4vqDqoIIcBTbZEE6",
        "x-authkey": "dgfJlO10QAoZzaiT8FXrF8bgBBQ5jghe7FNrd9t8D0u",
        "x-user-id": user_id || '',
        "x-device-type": "web",
        "x-app-version": "web",
        "x-device-name": "web",
        "x-device-os": "web",
        "x-device-id": "web"
    }
}

const register = ({
                      params
                  }) => {
    return getData({
        url: `${baseUrl}/customer/register`,
        headers: requestHeaders({}),
        contentType: "urlencoded",
        method: "POST",
        params: {
            ...params,
            password: "pankajsaini",
            user_type: "web",
            dob: "",
            s_media_type: "E-mail",
            s_media_id: "",
            referral_source: "SBI-YONO"
        }
    })
}

const activateMembershipUrl = ({params, app_key, user_id}) => {
    return getData({
        url: `${baseUrl}/customer/pendingorder`,
        headers: requestHeaders({
            app_key, user_id
        }),
        contentType: "urlencoded",
        method: "POST",
        params
    })
}

const getCorporateMembershipPlan = ({corporate_id, user_id, app_key}) => {
    return getData({
        url: `${baseUrl}/sbiyono/membershipplan`,
        method: "POST",
        headers: requestHeaders({user_id, app_key}),
        contentType: "urlencoded",
        params: {
            corporate_id
        }
    })
}

const getPendingOrder = ({params, user_id, app_key}) => {
    return getData({
        url: `${baseUrl}/customer/pendingorder`,
        contentType: "urlencoded",
        method: "POST",
        params,
        headers: requestHeaders({user_id, app_key})
    })
}

const afterPaymentMethod = (response) => {
    let params = {
        transaction_id: "${transaction_id}",
        payment_gateway_id: response.razorpay_payment_id,
        gateway_mode: "RozarPay"
    }
    var formBody = [];
    for (var property in params) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(params[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    fetch(`https://api-fitpass.in/payments/razorpay/activatecustomermembership`, {
        method: 'POST',
        body: formBody,
        headers: {
            "Cache-Control": "no-cache",
            "Content-Length": 217,
            "Content-Type": "application/x-www-form-urlencoded",
            "X-APP-VERSION": "4.4.8",
            "X-APPKEY": "rcmroes1UWF2GIcBBQ5jghe6xpwoQ4vqDqoIIcBTbZEE6",
            "X-AUTHKEY": "dgfJlO10QAoZzaiT8FXrF8bgBBQ5jghe7FNrd9t8D0u",
            "X-DEVICE-ID": "web",
            "X-DEVICE-NAME": "web",
            "X-DEVICE-OS": "web",
            "X-DEVICE-TOKEN": "web",
            "X-DEVICE-TYPE": "web"
        }
    }).then((resp) => resp.json())
        .then(result => {
            let {code, data, message} = result;
            if (code === 200) {
                let planForm = document.getElementById("planForm");
                let thankYouContainer = document.getElementById("thankYouContainer");
                thankYouContainer.style.display = "flex";
                planForm.style.display = "none";
                let thankYoupage = document.getElementById("thankYoupage");
                thankYoupage.style.height = "80%";
                thankYoupage.style.width = "80%";
                thankYoupage.style.opacity = 1;

            }
        })
}
const getPayment = ({
                        user_id,
                        transaction_id,
                        product_type,

                        after_discount_price,
                        plan_master_id,
                        user_details,

                    }) => {
    const payingScript = document.createElement('script');
    let { first_name, email_address, mobile_no } = user_details || {}
    payingScript.type = 'text/javascript';
    payingScript.innerHTML = `
    var options = {
        "key": "${razorpayId}",
        "name": "FITPASS",
        "amount": ${parseDecimal(after_discount_price * 100)}, 
        "description":"GET. SET. SWEAT.",
        "image": "https://cdn.razorpay.com/logos/CiwsBnHuskEFqB_medium.png",
        netbanking: true,
        currency: "INR",
         "handler":(response) => {
            let params = {
                transaction_id: "${transaction_id}",
                payment_gateway_id: response.razorpay_payment_id,
                gateway_mode: "RazorPay"
            }
            var formBody = [];
            for (var property in params) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(params[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            fetch("${baseUrl}/payments/razorpay/activatecustomermembership", {
                method: 'POST',
                body: formBody,
                headers: {
                    "Cache-Control": "no-cache",
                    "Content-Length": 217,
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-APP-VERSION": "4.4.8",
                    "X-APPKEY": "rcmroes1UWF2GIcBBQ5jghe6xpwoQ4vqDqoIIcBTbZEE6",
                    "X-AUTHKEY": "dgfJlO10QAoZzaiT8FXrF8bgBBQ5jghe7FNrd9t8D0u",
                    "X-DEVICE-ID": "web",
                    "X-DEVICE-NAME": "web",
                    "X-DEVICE-OS": "web",
                    "X-DEVICE-TOKEN": "web",
                    "X-DEVICE-TYPE": "web"
                }
            }).then((resp) => resp.json())
                .then(result => {
                    let { code, data, message } = result;
                    if (code === 200) {
                        let planForm = document.getElementById("planForm");
                        let thankYouContainer = document.getElementById("thankYouContainer");
                        thankYouContainer.style.display = "flex";
                        planForm.style.display = "none";
                        let thankYoupage = document.getElementById("thankYoupage");
                        thankYoupage.style.height = "80%";
                        thankYoupage.style.width = "80%";
                        thankYoupage.style.opacity = 1;
        
                    }
                })
        },
        "prefill": {
            "name": "${first_name || ""}",
            "email":"${email_address || ""}",
            contact:${mobile_no || ""},
        },
        "notes": {
            "transaction_id": "${transaction_id}",
            "product_type": "${product_type}",
            "user_id": "${user_id}",
            "plan_master_id": "${plan_master_id}",
            
        },
        "theme": {
            "color": "#528FF0"
        }
    };
    var rzp1 = new Razorpay(options);
    rzp1.open();`

    document.body.appendChild(payingScript);
}


const getTermsAndConditions = () => {
    return getData({
        url: `https://api-fitpass.in/page/termandconditions?type=web`,
        method: "GET",
        html: true,
        headers: requestHeaders({})
    })
}

export {
    register,
    getPendingOrder,
    getPayment,
    getCorporateMembershipPlan,
    getTermsAndConditions,
    activateMembershipUrl
}



